import {QueryClient, useQuery} from "react-query";
import * as api from "../api/companies";

const getCompany = async (companyId) => {
    return await api.fetchCompany(companyId);
};

export default function useCompany(companyId) {
    return useQuery(['company', {companyId}], () => getCompany(companyId), {refetchOnWindowFocus: false});
}
